import {
  updateRatingImage,
  creatCustomerPhotoQuery,
  ratings
} from 'src/app/queries/queries'

const fetchToteRatingDetails = (id, success = () => {}) => {
  return {
    type: 'API:TOTES:FETCH_TOTE',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    data: {
      query: ratings.QUERY_TOTE_RATING_DETAILS,
      variables: { id }
    }
  }
}

const rateTote = (tote_rating, toteId, success) => {
  const { ...rest } = tote_rating
  return {
    type: 'API:RATINGS:SUBMIT_TOTE_RATING',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: ratings.MUTATION_RATING_TOTE,
      variables: { tote_rating: { ...rest, tote_id: toteId } }
    },
    success
  }
}

const updateToteRating = toteRating => {
  return {
    type: 'RATINGS:UPDATE_TOTE_RATING',
    data: { toteRating }
  }
}

const rateProducts = (input, success) => {
  return {
    type: 'API:RATINGS:RATE_PRODUCTS',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: ratings.MUTATION_RATING_PRODUCTS,
      variables: { input: input }
    },
    success
  }
}

const updateServiceFeedback = (input, success) => {
  return {
    type: 'API:RATINGS:SERVICE_FEEDBACK',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: ratings.MUTATION_SERVICE_FEEDBACK,
      variables: { input: input }
    },
    success
  }
}

const updateImage = (input, tote_id, success, error) => {
  return {
    type: 'API:UPDATE:IMAGE',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      tote_id,
      query: updateRatingImage,
      variables: { input: input }
    },
    success,
    error
  }
}

const createCustomerPhoto = (input, data, success, error) => {
  return {
    type: 'API:CREATE:CUSTOMER:PHOTO',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: creatCustomerPhotoQuery,
      tote_id: data.tote_id,
      tote_product_id: data.tote_product_id,
      variables: { input: input }
    },
    success,
    error
  }
}

const setRatingToteId = id => {
  return { type: 'RATINGS:SET_RATING_TOTEID', id }
}

const resetRatingStore = () => ({ type: 'RESET:RATING:STORE' })

export default {
  fetchToteRatingDetails,
  rateTote,
  rateProducts,
  updateServiceFeedback,
  updateToteRating,
  updateImage,
  setRatingToteId,
  resetRatingStore,
  createCustomerPhoto
}
